import { isEqual, startOfDay } from "date-fns"
import { t } from "i18next"
import { getPersistedLanguage } from "@/lib/language-storage"
import { formatDateForChatConversation } from "@/modules/chats/lib/format-chat-date"
import { ChatMessageGroup, SofiaChatMessage } from "@/modules/chats/types/chat-message"

const isSeparatedToAnotherGroup = (currentMessage: SofiaChatMessage, previousMessage: SofiaChatMessage) => {
  const intervalInMinutes = 5
  return (currentMessage.sentAt.valueOf() - previousMessage.sentAt.valueOf()) / (1000 * 60) > intervalInMinutes
}

const formatChatMessageList = (chatMessages: SofiaChatMessage[]) => {
  const newChatMessages: SofiaChatMessage[] = []
  let prevDate: Date
  chatMessages.forEach((message, index) => {
    const currentDate = message.sentAt

    // If current date is different from previous date, insert a system message
    if (!isEqual(startOfDay(currentDate), startOfDay(prevDate))) {
      const systemMessage: SofiaChatMessage = {
        id: `System_${index}`,
        acsChatThreadId: message.acsChatThreadId,
        sentAt: currentDate,
        content: generateDateMessageContent(message.sentAt),
        senderDisplayName: "",
        type: "text",
        role: "system",
        acsSenderIdentity: null,
      }
      newChatMessages.push(systemMessage)
    }

    newChatMessages.push(message)
    prevDate = currentDate
  })

  return newChatMessages
}

const generateDateMessageContent = (messageSentDate: Date) => {
  const today = new Date()
  const language = getPersistedLanguage()

  if (isEqual(startOfDay(today), startOfDay(messageSentDate))) {
    return t("chat.date.today")
  } else {
    return `${formatDateForChatConversation(messageSentDate.toISOString(), language, true)}`
  }
}

const groupMessage = (messages: SofiaChatMessage[]): ChatMessageGroup[] => {
  const formattedMessages = formatChatMessageList(messages)
  const groupedMessages: ChatMessageGroup[] = []
  let currentGroup: SofiaChatMessage[] = []
  let groupMessageIndex = 0

  for (let i = 0; i < formattedMessages.length; i++) {
    if (
      (i === 0 ||
        formattedMessages[i].senderDisplayName !== formattedMessages[i - 1].senderDisplayName ||
        isSeparatedToAnotherGroup(formattedMessages[i], formattedMessages[i - 1]) ||
        formattedMessages[i].role === "system") &&
      currentGroup.length > 0
    ) {
      const newGroup: ChatMessageGroup = { id: groupMessageIndex, messages: currentGroup }
      groupedMessages.push(newGroup)
      groupMessageIndex++
      currentGroup = []
    }
    currentGroup.push(formattedMessages[i])
  }

  if (currentGroup.length > 0) {
    const newGroup: ChatMessageGroup = { id: groupMessageIndex, messages: currentGroup }
    groupedMessages.push(newGroup)
  }

  return groupedMessages
}

export { groupMessage }
